/**
 * Valida el formato de nombres de variables
 * Solo permite: minúsculas, números, guiones bajos (_) y guiones (-)
 * 
 * @param {string} name - Nombre de la variable a validar
 * @returns {Object} - { valid: boolean, error: string|null }
 */
export const validateVariableName = (name) => {
    if (!name || name.trim() === '') {
        return {
            valid: false,
            error: 'La variable es obligatoria'
        };
    }

    const regex = /^[a-z0-9_-]+$/;
    if (!regex.test(name)) {
        return {
            valid: false,
            error: 'Solo minúsculas, números, guiones bajos (_) y guiones (-)'
        };
    }

    return { valid: true, error: null };
};

/**
 * Valida que una variable sea única en una lista de tareas
 * 
 * @param {string} variableName - Nombre de la variable a validar
 * @param {Array} tasks - Lista de tareas existentes
 * @param {string|number} excludeId - ID de tarea a excluir (para edición)
 * @returns {Object} - { valid: boolean, error: string|null }
 */
export const validateUniqueVariable = (variableName, tasks, excludeId = null) => {
    const isDuplicate = tasks.some(task =>
        task.variable === variableName && task.id !== excludeId
    );

    if (isDuplicate) {
        return {
            valid: false,
            error: 'Esta variable ya está en uso por otra tarea'
        };
    }

    return { valid: true, error: null };
};
